import type { GeneralParameters } from '../../general/parameters/general'
import type { StreamInfoParameters } from '../parameters/stream-info'

import { Analytix } from '~/shared/analytix'
import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'
import { parameters } from '../parameters/stream-info'
import { getActivePlayerState } from '../players'

/**
 * Event wrapper for `stream_info`.
 */
export class StreamInfoEvent extends AnalytixEvent<StreamInfoParameters> {
  name = 'stream_info'
  group = 'player'
  parameters = parameters
  sender = Analytix.prototype.sendStreamInfoEvent

  gates = [Gate.Uses(seeds.session), Gate.Uses(seeds.player)]

  // do not expire
  override timeout = Infinity

  // partial snapshot of parameters at the moment of validation
  parametersSnapshot?: Partial<StreamInfoParameters>

  constructor() {
    super()
    this.verify()
  }

  override send(analytix: Analytix): Promise<boolean> {
    this.parametersView = {
      ...Object.fromEntries(this.parameters), // update parameters view just before sending
      ...this.parametersSnapshot,
    }
    return super.send(analytix)
  }

  validate(): false | [GeneralParameters, StreamInfoParameters] {
    const playerId = this.parameters.get('(playerId)')
    const player = getActivePlayerState(playerId)
    if (player == null) return false

    const trafficMap = this.parameters.get('(traffic)') ?? new Map()
    const { bytes = 0, bandwidth = 0 } = trafficMap.get(player.playerId) ?? {}
    trafficMap.set(player.playerId, { bytes: 0, bandwidth })
    this.parameters.set('(traffic)', trafficMap).notify()

    const parameters: StreamInfoParameters = {}
    parameters.bitrate = String(bandwidth)
    parameters.bufferState = this.parameters.get('bufferState')
    parameters.cdnTraffic = String(bytes)
    parameters.contentDrm = player.drm ?? ''
    parameters.playbackSessionId = player.playbackSessionId
    this.parametersSnapshot = parameters

    return [Object.fromEntries(this.general), {}]
  }
}
